var exports = {
  "Y9": "Header__dBDY2c",
  "hE": "Title__DoFXAh",
  "mO": "Wrapper__ecfAqP",
  "sd": "SelectBodyWrapper__83yt8q",
  "R4": "DialogBody__BNhqL-",
  "wi": "Footer__eXPs-z",
  "RH": "FooterContent__IUsQ9u",
  "$z": "FooterActions__q_a1Es",
};

module.exports = exports;
